import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipVipHistoryList } from "../../modules/vipVipHistory/components/VipVipHistoryList";

const VipVipHistoryContext = createContext();

const VipVipHistoryWrapper = () => {
  const value = {};

  return (
    <VipVipHistoryContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipVipHistoryList />} />
      </Routes>
    </VipVipHistoryContext.Provider>
  );
};

export { VipVipHistoryWrapper };
